var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "sub-title" }, [_vm._v("设置发起人")]),
      _c("div", { staticClass: "sub-title-tips" }, [_vm._v("发起人范围")]),
      _c(
        "el-select",
        {
          staticClass: "select-u",
          attrs: {
            "value-key": "name",
            placeholder: "发起人范围",
            size: "medium",
            multiple: "",
            "popper-class": "hidden",
          },
          on: { "remove-tag": _vm.removeTag },
          nativeOn: {
            click: function ($event) {
              return _vm.selectUser.apply(null, arguments)
            },
          },
          model: {
            value: _vm.setup.whoCommit,
            callback: function ($$v) {
              _vm.$set(_vm.setup, "whoCommit", $$v)
            },
            expression: "setup.whoCommit",
          },
        },
        _vm._l(_vm.setup.whoCommit, function (wc, index) {
          return _c("el-option", {
            key: index,
            attrs: { label: wc.name, value: wc },
          })
        }),
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "发起人范围", multiple: "", selected: _vm.select },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }